import styled, { css } from 'styled-components';
import { colors, colorAliases } from '../../variables/colors.js';
import { fonts } from '../../variables/fonts.js';

var messageColors = {
  error: {
    background: 'rgba(255, 90, 82, 0.15)',
    icon: colors.morello
  },
  warning: {
    background: '#FDF8CF',
    icon: colors.core
  },
  'critical-warning': {
    background: 'rgba(255, 90, 82, 0.15)',
    icon: colors.morello
  },
  info: {
    background: '#D6E2E5',
    icon: colors.wave
  },
  'important-info': {
    background: '#FDF8CF',
    icon: colors.core
  },
  success: {
    background: 'rgba(192, 203, 162, 0.8)',
    icon: colors.olive
  },
  guide: {
    background: 'rgba(192, 203, 162, 0.8)',
    icon: colors.olive
  }
};
var partnerColors = {
  ica: '#ed1c24',
  plussa: '#f6841f',
  loFavor: '#df1a22',
  coop: '#003366',
  aldreSagen: '#ab2026',
  veronmaksajat: '#0042D9'
};
var Message = styled.div.withConfig({
  displayName: "style__Message",
  componentId: "sc-21xpys-0"
})(["background-color:", ";border-radius:2px;box-shadow:0 0 1px ", ";font-family:", ";font-size:16px;line-height:22px;width:100%;color:", ";", " ", ""], colors.white, colorAliases.shadow, fonts["default"], colors.almostblack, function (props) {
  return props.messageType && css(["background-color:", ";"], messageColors[props.messageType].background);
}, function (props) {
  return props.partner && css(["border-left:5px ", " solid;"], partnerColors[props.partner]);
});
var MessageTop = styled.div.withConfig({
  displayName: "style__MessageTop",
  componentId: "sc-21xpys-1"
})(["display:flex;padding:18px 32px 18px 18px;", " .sg-message-type-icon{margin-right:18px;width:32px;min-width:32px;height:32px;min-height:32px;fill:", ";", "}img{margin-right:18px;}"], function (props) {
  return props.expandableWithChildren && css(["align-items:center;cursor:pointer;"]);
}, colors.darkGray, function (props) {
  return props.messageType && css(["fill:", ";"], messageColors[props.messageType].icon);
});
var MessageTopContent = styled.div.withConfig({
  displayName: "style__MessageTopContent",
  componentId: "sc-21xpys-2"
})(["display:flex;flex-direction:column;flex-grow:1;", " ", ""], function (props) {
  return !props.expandableWithChildren && css(["margin-top:-4px;"]);
}, function (props) {
  return props.noChildren && css(["justify-content:center;margin-top:0;"]);
});
var Header = styled.button.withConfig({
  displayName: "style__Header",
  componentId: "sc-21xpys-3"
})(["align-items:flex-start;color:", ";display:flex;font-family:", ";font-size:16px;font-weight:600;align-items:center;width:100%;cursor:default;text-align:left;", " ", " .sg-message-expand-icon{height:15px;width:15px;min-width:15px;min-height:15px;fill:", ";", "}"], colorAliases.text, fonts["default"], function (props) {
  return props.expandableWithChildren && css(["cursor:pointer;"]);
}, function (props) {
  return props.partner && css(["font-weight:normal;color:", ";"], partnerColors[props.partner]);
}, colors.darkGray, function (props) {
  return props.expandableWithChildren && css(["margin-left:15px;"]);
});
var HeaderContent = styled.div.withConfig({
  displayName: "style__HeaderContent",
  componentId: "sc-21xpys-4"
})(["display:flex;flex-grow:1;margin-bottom:2px;"]);
var MessageBottom = styled.div.withConfig({
  displayName: "style__MessageBottom",
  componentId: "sc-21xpys-5"
})(["height:0;overflow:hidden;", ""], function (props) {
  return props.expanded && css(["overflow:visible;height:auto;padding:0 40px 18px 68px;margin-top:-10px;"]);
});
var BodyLink = styled.div.withConfig({
  displayName: "style__BodyLink",
  componentId: "sc-21xpys-6"
})(["margin-top:5px;"]);
var MessageBody = styled.div.withConfig({
  displayName: "style__MessageBody",
  componentId: "sc-21xpys-7"
})(["padding-right:20px;margin-top:2px;", " a,span{color:", ";border-color:", ";}"], function (props) {
  return props.expandable && css(["margin-top:-5px;"]);
}, colors.almostblack, colors.almostblack);

export { BodyLink, Header, HeaderContent, Message, MessageBody, MessageBottom, MessageTop, MessageTopContent };
//# sourceMappingURL=style.js.map
